export default __webpack_public_path__ + "static/media/VisiGift.69c18e722f1c1ad1b362350028de2305.webp";